import React from 'react';
import { Box } from '@mui/material';

function ToggleContainer({ open = false, wrapperStyle = {}, containerStyle = {}, ...props }) {
    const gridTemplateRows = open ? "1fr" : "0fr";
    const overflow = open ? "unset" : "hidden";
    const defStyle = { display: "grid", gridTemplateRows, overflow, transition: "all 200ms" }
    if (!open) { wrapperStyle.padding = 0; containerStyle.padding = 0; }

    return (
        <Box component={'div'} sx={{ ...defStyle, ...wrapperStyle }}>
            <Box component={'div'} {...props.containerProps} sx={{ overflow, minHeight: 0, ...containerStyle }} >
                {props.children}
            </Box>
        </Box>
    );
}

export default ToggleContainer;